import { ClaimTypeGetUseCase } from '../../../application';

export default class ClaimTypeGetService {
    constructor() {}

    async execute(event) {
        const request = await ClaimTypeGetUseCase(event);

        return request;
    }
}
